<template>
	<transition name="lp-fade">
		<div class="lp-overlay" v-if="visible" @click.self="close">
			<div class="lp-popup">
				<img class="lp-close" src="./closure.png" alt="" @click="close">
				<div class="lp-content">
					<slot></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'LotteryPrizePopup',
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped>
.lp-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.lp-popup {
	position: relative;
	width: 8.4rem;
	min-height: 4rem;
	background-image: url('./pop-up-window.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	display: flex;
	align-items: center;
	justify-content: center;
}

.lp-close {
	position: absolute;
	top: -0.16rem;
	right: -0.16rem;
	width: 0.5rem;
	height: 0.5rem;
	cursor: pointer;
	z-index: 10;
}

.lp-content {
	padding: 0.5rem 0.4rem;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	max-height: 70vh;
	overflow-y: auto;
	box-sizing: border-box;
}

.lp-content::-webkit-scrollbar {
	width: 0.08rem;
}

.lp-content::-webkit-scrollbar-thumb {
	border-radius: 0.08rem;
	background: rgba(0, 0, 0, 0.28);
}

.lp-fade-enter-active,
.lp-fade-leave-active {
	transition: opacity 0.2s ease;
}

.lp-fade-enter,
.lp-fade-leave-to {
	opacity: 0;
}

@media (max-width: 768px) {
	.lp-popup {
		width: 7.2rem;
		min-height: 5.2rem;
	}

	.lp-content {
		max-height: 68vh;
	}

	.lp-close {
		top: -0.22rem;
		right: -0.22rem;
		width: 0.7rem;
		height: 0.7rem;
	}
}
</style>
